import React, { useContext, useEffect, useState } from "react";
import CategoryProductList from "../../CategoryProductList";
import { LanguageContext } from "../../../App";

function CategoryDropList({
  category,
  idx,
  setcategoryopen,
  categorynow,
}) {
  const [loading, setLoading] = useState(false);
  const { language } = useContext(LanguageContext);

  return (
    <div
      id={`category${idx}`}
      className="accordion-container category-accordion-div"
    >
      <button
        onClick={() => {
          setcategoryopen(true);
        }}
        className={`category-accordion ${categorynow == "" || categorynow == category?.category_name
          ? "active"
          : ""
          }`}
      >
        {language === "ltr"
          ? category?.category_name
          : category?.category_name_ar}
      </button>
      <div
        className={`area-list-collapse ${categorynow == "" || categorynow == category?.category_name
          ? "active"
          : ""
          }`}
      >
        <CategoryProductList
          loading={loading}
          products={category?.products}
        ></CategoryProductList>
      </div>
    </div>
  );
}

export default CategoryDropList;
